module.exports = {
  Lang: {
    de: 'German',
    en: 'English'
  },
  Action: {
    add: 'Add',
    edit: 'Edit',
    remove: 'Remove',
    close: 'Close',
    select: 'Select',
    save: 'Save',
    saving: 'Saving',
    send: 'Send',
    confirmSelection: 'Confirm selection',
    change: 'Change',
    changeSelection: 'Change selection',
    next: 'Next',
    prev: 'Previous',
    finish: 'Finish',
    'search': 'Search'
  },
  Common: {
    start: 'Start',
    date: 'Date',
    creationdate: 'Creation date',
    lastmodified: 'Last modified',
    status: 'Status',
    color: 'Color',
    settings: 'Settings',
    masterdata: 'Master data',
    masterdataSaved: 'Master data saved',
    amount: 'Amount',
    description: 'Description',
    item: 'Item',
    itemNum: 'Item no.',
    itemName: 'Item name',
    itemPrice: 'Item price',
    quantity: 'Quantity',
    singlePrice: 'Sellingprice',
    discount: 'Discount',
    rebate: 'Rebate',
    vat: 'VAT',
    total: 'Total',
    orderPrice: 'Order price',
    annotation: 'Annotation',
    accountDetails: 'Account details',
    customerNum: 'Customer no.',
    salutation: 'Title',
    firstname: 'Firstname',
    lastname: 'Lastname',
    company: 'Company',
    email: 'Email',
    contact: 'Contact',
    address: 'Addresse',
    postalcode: 'Postalcode',
    city: 'City',
    country: 'Country',
    taxDetails: 'Tax details',
    vatId: 'VAT ID',
    noEntries: 'No entries',
    languageSettings: 'Language settings',
    showXtoYentries: 'Showing {x} to {y} results',
    showXtoYofZentries: 'Showing {x} to {y} out of {z} results',
    errorSavingMasterdata: 'Could not save masterdata.',
    errorIncomplete: 'Incomplete form',
    errorFieldMissing: '{field} is missing',
    errorUploadInvalidResp: 'Invalid server response. Please try again or contact our support.'
  },
  Units: {
    DAY: "PD",
    LH: "STD",
    LS: "FIX",
    C62: "PCS",
    SET: "SET",
    KMT: "KM",
    MTR: "M",
    LIC: "License",
    ANN: "Year",
    MON: "MON",
    LTR: "LTR",
    CNP: "100-Pack",
    GRM: "GRM",
    E27: "Unit"
  },
  Dashboard: {
    title: 'Dashboard',
    NewConstruction: 'New Construction',
    NewProduction: 'New Production',
    CreateNewCase: 'Create new case/project'
  },
  Addresses: {
    title: 'Addresses',
    add: 'New Address',
    addressMain: 'Main address',
    addressBilling: 'Billing address',
    addressShipping: 'Shipping address',
    confirmRemove: 'Do you really want to remove this address?',
    errorLoad: 'Address could not be loaded.',
    errorRemove: 'Address could not be removed.'
  },
  EditAddress: {
    title: 'New Address',
    errorTypeTitle: 'Please specify an address type.',
    errorTypeText: 'The address must be a billing and/or shipping address.',
    errorCreate: 'Could not create address.',
    errorUpdate: 'Could not update address',
    shipping: 'Shipping',
    useForShippingNo: 'Do not use for shipping',
    useForShippingYes: 'Use as shipping address',
    useForShippingDefault: 'Use as default shipping address',
    billing: 'Billing',
    useForBillingNo: 'Do not use for billing',
    useForBillingYes: 'Use as billing address',
    useForBillingDefault: 'Use as default billing address'
  },
  Projects: {
    title: 'Drafts',
    loading: 'Loading drafts',
    currentProjects: 'Current drafts',
    showAll: 'Show all drafts',
    noProjects: 'No drafts',
    add: 'New order',
    projectNumber: 'Order no.',
    projectName: 'Reference',
    projectType: 'Order type',
    statusAll: 'All drafts',
    statusOpen: 'Open drafts',
    statusOrdered: 'Ordered drafts',
    errorNoName: 'Please enter an order name.',
    errorCreate: 'Draft could not be created.',
    errorCouldNotLoad: 'Drafts could not be loaded.'
  },
  ProjectDetails: {
    title: 'Details of draft',
    loading: 'Loading draft',
    alertOrdered: 'Draft ordered:',
    openOrder: 'Open draft',
    alertReference: 'This draft is linked to another draft:',
    openProject: 'Open draft',
    toothSelection: 'Tooth selection',
    noConstruction: 'No construction',
    editConstruction: 'Edit construction',
    materialSelection: 'Material selection',
    estimatedDelivery: 'Estimated shipping date',
    missingMaterial: 'Material selection is missing',
    missingAttachments: 'Missing attachments',
    addStl: 'Add STL',
    openCart: 'Open cart',
    emptyCart: 'Empty cart',
    shippingType: 'Shipping method',
    construction: 'Construction',
    stlUpload: 'STL upload',
    attachments: 'Attachments',
    addons: 'Addons',
    cart: 'Cart',
    addItem: 'Add item',
    orderProject: 'Order draft',
    statusNotOrdered: 'Not ordered',
    statusOrdered: 'Ordered',
    errorNoProjectnum: 'No valid project number'
  },
  Orders: {
    title: 'Orders',
    loading: 'Loading orders',
    currentOrders: 'Current orders',
    openOrder: 'Open order',
    showAll: 'Show all orders',
    noOrders: 'No orders',
    orderNum: 'Order no.',
    projectRef: 'Reference',
    statusAll: 'All orders',
    statusReceived: 'Received',
    statusReceivedDescr: 'Your order is being reviewed',
    statusInProgress: 'In progress',
    statusInProgressDescr: 'Your order is being processed',
    statusInProduction: 'In production',
    statusInProductionDescr: 'Production has started',
    statusOnHold: 'On hold',
    statusCancelled: 'Cancelled',
    statusCancelledDescr: 'Your order has been cancelled',
    statusClosed: 'Closed',
    statusCompleted: 'Completed',
    statusInvoicedCancelled: 'Invoiced / cancelled',
    statusPartlyDelivered: 'Partly delivered',
    statusPartlyDeliveredCancelled: 'Partly delivered / cancelled',
    statusPartlyDeliveredClosed: 'Partly delivered / closed',
    statusDelivered: 'Delievered',
    statusReadyForPickup: 'Ready for pickup',
    errorCouldNotLoad: 'Could not load order'
  },
  OrderDetails: {
    title: 'Order details',
    deliveryNote: 'Delivery note',
    loading: 'Loading order',
    trackingNum: 'Tracking no.',
    manufacturingStatus: 'Manufacturing status',
    trackingAndBilling: 'Tracking and billing',
    creatingOrder: 'Creating order',
    orderProject: 'Order project',
    placeOrder: 'Place order',
    acceptTerms: 'I have read and accepted the <a href="{termsUrl}" target="_blank">Terms of Service</a>.',
    errorNoOrderNum: 'Invalid order number',
    errorCouldNotLoad: 'Could not load order',
    priceNobleMetal1: 'The final product price for noble metals is calculated based on the product\'s final weight.',
    priceNobleMetal2: 'Please check your delivery note once you receive the shippment for further details.'
  },
  Messages: {
    title: 'Messages',
    noMessages: 'No messages',
    errorCouldNotLoad: 'Could not load messages'
  },
  Configurator: {
    selectIndication: 'Select indication',
    changeMaterial: 'Change material',
    selectTooth: 'Please select a tooth',
    showToothNumbers: 'Show tooth numbers',
    toothSelection: 'Tooth selection',
    setProductProps: 'Set product properties',
    selectProduct: 'Select product',
    fileXofY: 'File {x} of {y}',
    calcPrice: 'Calculating prices',
    uploadStl: 'Upload STL',
    stlCount: 'Unit count for this STL',
    stlCountTooltip: 'Please select the number of units for this STL,',
    oneUnit: 'One unit',
    nUnits: '{n} units',
    removeJawSelection: 'Do you want to remove the product selection for this jaw?'
  },
  Invoices: {
    title: 'Invoices',
    loading: 'Loading invoices',
    invoiceNum: 'Invoice no.',
    monthlyStatement: 'Monthly statement',
    statusReceived: 'Received',
    statusOpen: 'Open',
    statusHold: 'On hold',
    statusCancelled: 'Cancelled',
    statusClosed: 'Closed',
    statusPartlyPaid: 'Partly paid',
    statusPartlyPaidCancelled: 'Partly paid / cancelled',
    statusPartlyPaidClosed: 'Partly paid / closed',
    statusPaid: 'Paid'
  },
  Messages: {
    title: 'Messages',
    noMessages: 'No messages',
    writeSomething: 'Write something...',
    errorSendingMessage: 'Error sending message.'
  },
  File: {
    name: 'File name',
    hash: 'File hash',
    messageUpload: 'Click field or drag/drop file to upload',
    allFilesSameMaterial: 'All files have the same material',
    sendingData: 'Sending data',
    processingData: 'Processing data',
    errorUpload: 'An error occured. Could not upload file.',
    errorCouldNotList: 'Could not load files.',
    errorCouldNotLoad: 'Could not load file.',
    errorCouldNotDelete: 'Could not delete files.'
  },
  Login: {
    username: 'Customer number',
    password: 'Password',
    passwordOld: 'Old password',
    passwordNew: 'New password',
    passwordConfirm: 'Confirm new password',
    passwordSaved: 'Password updated',
    login: 'Login',
    logout: 'Logout',
    enterPwd: 'Please enter your password',
    invalidUserOrPwd: 'Invalid username or password',
    errorCouldNotUpdate: 'Could not update password.',
    errorPasswordNoMatch: 'Passwords do not match.',
    errorOldPassword: 'Your old password is wrong.',
    errorNoSession: 'No active user session found. Please log in.'
  }
};
